import store from '@/store';
import { CLEAR_ERRORMSG, LOGOUT } from '@/store/action_types';
import {
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  LOGIN_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
} from '@/router/routes';
import { RouteLocationNormalized } from 'vue-router';
import { resetLoaders } from '@/utils/loaders';

export const ifAuthDeny = async (to: any, from: any, next: Function) => {
  store.dispatch(CLEAR_ERRORMSG);
  resetLoaders();

  const sessionToken = store.getters.sessionToken;
  const accountData = store.getters.account.data;

  if (sessionToken == null || accountData == null) {
    if (
      to.name === FORGOT_PASSWORD_ROUTE ||
      to.name === RESET_PASSWORD_ROUTE
    ) {
      return next();
    }

    if (to.name !== LOGIN_ROUTE) {
      return next({ name: LOGIN_ROUTE });
    } else {
      return next(); // Prevent redirect loop
    }
  }

  console.log('from.name', from.name);
  console.log('to.name', to.name);

  next();
};

export const logoutGuard = async (to: any, from: any, next: Function) => {};
